import React from "react"
import { Form2 } from "@cd2/forms"
import { Button } from "@cd2/components/build/es6"

export interface ISubmitProps {
  value?: React.ReactNode
  disabled?: boolean
}
export function SubmitButton({ value = "Submit", disabled }: ISubmitProps) {
  const passedProps = {
    theme: {
      padding: 11,
      fontSize: 14,
      buttonColor: "primary",
    },
    disabled,
  }

  return (
    <div>
      <Form2.Submit buttonProps={{ ...passedProps }} value={value as string} />
    </div>
  )
}

export function SubmitButtonNotForm({
  onClick,
  value,
  disabled,
}: {
  onClick: () => void
  value?: React.ReactNode
  disabled?: boolean
}) {
  return (
    <Button
      extendTheme={{
        padding: 11,
        fontSize: 14,
        buttonColor: "primary",
      }}
      onClick={onClick}
      disabled={disabled}
    >
      {value ?? "Submit"}
    </Button>
  )
}
